export const websocketUrl: string = import.meta.env.VITE_WEBSOCKET_BASE_URL;

export const loginUrl: string = 'authentication/token/';
export const passwordChangeUrl: string = 'authentication/change-password/';
export const passwordResetUrl: string = 'authentication/password_reset/';
export const passwordResetChangeUrl: string = 'authentication/password_reset/confirm/';
export const getTerritoriesUrl: string = 'territories/';
export const getTerritoryUrl = (territorySlug: string): string => {
  return `territories/${territorySlug}/`;
};

export const getTerritoryTerritoryIntegrationsUrl = (territorySlug: string): string => {
  return `territories/${territorySlug}/territory_integrations/`;
};

export const getWebsocketTokenUrl: string = 'authentication/websocket/token/';
export const getMissionsUrl = (
  territorySlug: string,
  queryParameters: Record<string, string>,
): string => {
  const newParams = new URLSearchParams(queryParameters);
  return `territories/${territorySlug}/missions?` + newParams.toString();
};

export const getMissionsDetailUrl = (territorySlug: string, missionId: string): string => {
  return `territories/${territorySlug}/missions/${missionId}/`;
};

export const getMissionHistoryUrl = (territorySlug: string, missionId: string): string => {
  return `territories/${territorySlug}/missions/${missionId}/history/`;
};
export const patchMissionsUrl = (territorySlug: string, missionId: number): string => {
  return `territories/${territorySlug}/missions/${missionId}/`;
};
export const getVehiclesUrl = (territorySlug: string): string => {
  return `territories/${territorySlug}/vehicles/`;
};

export const patchVehicleUrl = (territorySlug: string, vehicleId: number): string => {
  return `territories/${territorySlug}/vehicles/${vehicleId}/`;
};

export const getStatisticsUrl = (
  territorySlug: string,
  queryParameters: Record<string, string>,
): string => {
  const newParams = new URLSearchParams(queryParameters);
  return `territories/${territorySlug}/statistics?` + newParams.toString();
};

export const getShiftUrl = (territorySlug: string, vehicleId: number): string => {
  return `territories/${territorySlug}/vehicles/${vehicleId}/current-or-next-shift/`;
};
export const getIntegrationsUrl = (territorySlug: string, vehicleId: number): string => {
  return `territories/${territorySlug}/vehicles/${vehicleId}/integrations/`;
};
export const getRoadmapUrl = (territorySlug: string, vehicleId: number | undefined): string => {
  return `territories/${territorySlug}/vehicles/${vehicleId}/roadmap/`;
};
export const getAlertsUrl = (territorySlug: string, queryParameters: Record<string, string>): string => {
  const newParams = new URLSearchParams(queryParameters);
  return `territories/${territorySlug}/alerts?` + newParams.toString();
};
export const patchAlertsUrl = (territorySlug: string, alertId: number): string => {
  return `territories/${territorySlug}/alerts/${alertId}/`;
};
export const getVehiclesAutomataLogsUrl = (territorySlug: string, vehicleId: number): string => {
  return `territories/${territorySlug}/vehicles/${vehicleId}/automata-logs/`;
};
export const getVehiclesLogsUrl = (territorySlug: string, vehicleId: number): string => {
  return `territories/${territorySlug}/vehicles/${vehicleId}/logs/`;
};
export const getCreateMissionUrl = (territorySlug: string, vehicleId: number): string => {
  return `territories/${territorySlug}/vehicles/${vehicleId}/create-mission/`;
};
export const getActivateIntegrationUrl = (territorySlug: string, vehicleId: number): string => {
  return `territories/${territorySlug}/vehicles/${vehicleId}/activate-integration/`;
};
export const getTerritoryConsolidatedGeographyUrl = (territorySlug: string): string => {
  return `territories/${territorySlug}/geography/`;
};
export const getShuttleProviderGeographyUrl = (territorySlug: string): string => {
  return `territories/${territorySlug}/shuttle-provider-geography/`;
};
export const triggerGeographyRefreshUrl = (
  territorySlug: string,
  territoryIntegrationId: number,
): string => {
  return `territories/${territorySlug}/territory_integrations/${territoryIntegrationId}/refresh-geography/`;
};
export const getMappedGeographyUrl = (territorySlug: string, territoryIntegrationId: number): string => {
  return `territories/${territorySlug}/territory_integrations/${territoryIntegrationId}/mapped_geography/`;
};
export const getGeographyMappingSuggestionUrl = (
  territorySlug: string,
  territoryIntegrationId: number,
): string => {
  return `territories/${territorySlug}/territory_integrations/${territoryIntegrationId}/mapping-suggestion/`;
};
export const getGeographyMappingUpdateUrl = (
  territorySlug: string,
  territoryIntegrationId: number,
): string => {
  return `territories/${territorySlug}/territory_integrations/${territoryIntegrationId}/update-geography-mapping/`;
};
export const getConfigurationUrl = (territorySlug: string, vehicleId: number): string => {
  return `territories/${territorySlug}/vehicles/${vehicleId}/configuration/`;
};
export const getPostActionUrl = (territorySlug: string, vehicleId: number): string => {
  return `territories/${territorySlug}/vehicles/${vehicleId}/do-action/`;
};
